import React from 'react';
import { Field, FieldProps } from 'formik';
import { useDispatch } from 'react-redux';

import { updateTooltip } from '../../store/suggestionsSlice';
import * as S from '../../styles/Common.styles';

interface Props {
    name: string;
    index: number;
    fieldKey: 'title' | 'text';
    maxLength: number;
    placeholder: string;
    value: string;
}

export const SuggestionField = ({
    name,
    index,
    fieldKey,
    maxLength,
    placeholder,
    value,
}: Props) => {
    const dispatch = useDispatch();

    return (
        <Field name={name}>
            {({ field }: FieldProps) => (
                <S.Input
                    {...field}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    value={value}
                    onChange={e => {
                        field.onChange(e);
                        dispatch(
                            updateTooltip({
                                index,
                                field: fieldKey,
                                value: e.target.value,
                            })
                        );
                    }}
                />
            )}
        </Field>
    );
};
